import React from 'react';
import "./leadership.css";
import InfoBox from "../../common/infobox/Infobox";
import data from "../../../configs/leadership/leadership.json";
import Carousel from "../../common/carousel/Carousel";
const Leaders = () => {
  return (
    <div className="leadership-inside-uc" id="leaders">
      <div className="leadership-uc-heading">Leadership</div>
      <div className="leadership-listOfInfoBox">
        {window.innerWidth > 768 && (
          <Carousel
            width={1176}
            items={4}
            size={data.leadership.length}
            showDot={true}
            showArrow={true}
          >
            {data.leadership.map((leaders) => {
              return (
                <InfoBox
                  title={leaders.title}
                  description={leaders.description}
                  link={leaders.navigationLinks}
                  image={leaders.imageLink.web}
                  socialMedia={true}
                />
              );
            })}
          </Carousel>
        )}
        {window.innerWidth <= 768 && (
          <Carousel
            width={359}
            items={2}
            size={data.leadership.length}
            showDot={true}
            showArrow={true}
          >
            {data.leadership.map((leaders) => {
              return (
                <InfoBox
                  title={leaders.title}
                  description={leaders.description}
                  link={leaders.navigationLinks}
                  image={leaders.imageLink.mobile}
                  socialMedia={true}
                />
              );
            })}
          </Carousel>
        )}
      </div>
    </div>
  );
};

export default Leaders;
